export enum AddressTypeEnum {
	ORIGIN = 'ORIGIN',
	DESTINATION = 'DESTINATION',
}
